import React from 'react';

export const ClientConfigContext = React.createContext({ bgColor: null, Logo: null });

export default ClientConfigContext;
